const state = {
  weiXinDistributionOne: {}
}

const getters = {
  weiXinDistributionOne: state => state.weiXinDistributionOne
}

const actions = {
  setWeiXinDistributionOne ({ commit }, data) {
    commit('setWeiXinDistributionOne', data)
  }
}

const mutations = {
  setWeiXinDistributionOne (state, data) {
    state.weiXinDistributionOne = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/weixin/distribution_detail.js